
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TeamModel } from './Identity.Api.Models.Team';
import { Model, ModelProperty } from 'models/Model';


export class TeamCredentialModel extends Model<TeamCredentialModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'teamId', type: 'guid', languageString: 'teamCredential.property.teamId' },
		{ name: 'credential', type: 'number', languageString: 'teamCredential.property.credential' },
		{ name: 'team', type: 'TeamModel', languageString: 'teamCredential.property.team', isHidden: true, isObject: true, new: () => { return new TeamModel }, properties: () => { return TeamModel.classProperties } }
	];
	[key: string]: any;
	
	public teamId?: string;
	public credential: number;
	public team?: TeamModel;
    
	constructor(){
		super();
		this.teamId = undefined;
		this.credential = 0;
		this.team = undefined;
		
	}
	getProperties(){
		return TeamCredentialModel.classProperties;
	}
}

